import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { apiGetConfig, apiUpdateTemplate } from '../../../../utils/api'
import { Button, Image, Input } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { prMain } from '../../../../themeConfig'
import { openMessage } from '../../Utils/MessageDisplay'

export const EventsConfig = () => {

    const [values, setvalues] = useState({})
    const [image, setimage] = useState(null)
    const [urlImage, seturlImage] = useState("")
    const [loading, setloading] = useState(false)

    useEffect(() => {
        apiGetConfig().then(res => {
            res.data = res.data.find(i => i.typeServices === 'template')
            console.log(res.data)
            /* Replacing all the `/` in the string with nothing. */
            // console.log(JSON.parse(res.data.urlImage.replace(/\\/g, '')))
            let template = JSON.parse(res.data.urlImage.replace(/\\/g, ''))

            setvalues(prev => ({ ...prev,id: res.data.idConfiguration, title: template.title, message: template.message }))
            seturlImage(template.footPage)

        }).catch(err => {
            new Error(err)
        })
    }, [])

    const handleChange= (e, key) => {
        setvalues(prev => ({...prev, [key]: e.target.value}))
    }

    const handleImage = (e) => {

        if (!e) return

        setimage(e.target.files[0])
        seturlImage(URL.createObjectURL(e.target.files[0]))

    }

    const handleSubmit = () => {
        setloading(true)
        apiUpdateTemplate(values.id, image, values.title, values.message).then(res => {
            openMessage({type: 'success', message: `Plantilla Actualizada Con Éxito`})
            setimage(null)
            console.log(res)
        }).catch(err => {
            openMessage({type: 'error', message: `Ha ocurrido un error al intentar actualizar la plantilla`})
            new Error(err)
        }).finally(() => {
            setloading(false)
        })
    }

    return (
        <div>
            <div style={{fontSize: '1.2rem', textTransform: 'capitalize'}}>Plantilla del mensaje de resultado de los eventos</div>
            <div style={{marginBottom: '1rem', fontSize: '0.8rem', opacity: 0.7}}>Para actualizar la plantilla debe cambiar el pie de página</div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '1rem', marginBottom: '1.5rem' }}>
                <div style={{ position: 'relative', width: '50%' }}>
                    <label style={{ fontSize: '0.75rem', opacity: 0.6 }}>Título del Mensaje *</label>
                    <Input
                        id='title'
                        name='title'
                        onChange={(e) => handleChange(e, "title")}
                        value={values.title}
                        style={{ height: 30 }}
                        size='small'
                        placeholder='Ingrese el titulo del mensaje'
                    />
                </div>
                <div style={{ position: 'relative', width: '50%' }}>
                    <label style={{ fontSize: '0.75rem', opacity: 0.6 }}>Descripción del Mensaje *</label>
                    <Input
                        id='message'
                        name='message'
                        onChange={(e) => handleChange(e, "message")}
                        value={values.message}
                        style={{ height: 30 }}
                        size='small'
                        placeholder='Ingrese la descripción del mensaje'
                    />
                </div>

                <div style={{ width: 'fit-content', justifyContent: 'center' }}>
                    <label style={{ backgroundColor: prMain }} className='input-container' >
                        <UploadOutlined style={{ marginRight: 10 }} />
                        <input
                            id={'messageImageInput'}
                            className='inputSelect'
                            type="file"
                            onChange={handleImage}
                        />
                        {`Seleccionar Pie de Página`}
                    </label>
                    <div style={{ height: 'fit-content', maxHeight: 300, display: 'flex', width: 450, flexDirection: 'column', justifyContent: 'center', marginTop: 15 }}>
                        {
                            (urlImage)
                                ?
                                <>
                                    <Image id={'eventImage'} src={urlImage} alt={'Imagen del evento'} height={300} style={{ objectFit: 'cover' }} />
                                    {/* <Button icon={<DeleteFilled />} type='link' onClick={() => handleRemoveImage()}>Remover</Button> */}
                                </>
                                :
                                <Image
                                    style={{ objectFit: 'cover' }}
                                    width={'100%'}
                                    height={300}
                                    src="error"
                                    fallback="data:image/png;base64,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"
                                />
                        }
                        {/* {urlImage && <Button icon={<DeleteFilled />} type='link' onClick={() => handleRemoveImage('messageImageInput')}>Remover</Button>} */}
                    </div>
                </div>
                <Button loading={loading} type='primary' disabled={!values.title || !values.message || !image} onClick={handleSubmit}>Actualizar</Button>
            </div>

        </div>
    )
}
